import { commentsData } from '@/mocks/home';

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-10 md:mb-12">
          影迷心声
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 rounded-lg p-5 border border-background-200/60 flex flex-col"
            >
              <div className="flex items-center gap-2 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-xs w-3 h-3 flex items-center justify-center ${
                      i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed flex-1 mb-4 line-clamp-4">
                &ldquo;{comment.text}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-200/50">
                <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-xs font-medium text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-500">{comment.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}